export const GET_POSITION_TOTAL_JOB = 'total_job';
export const DEFAULT_FILTER_AT_LEVEL = 'Level';
export const DEFAULT_FILTER_AT_POSITION = 'Position';
